import { InvokeCommand } from '@aws-sdk/client-lambda';
import { axiosTemplate } from '../../axiosTemplate';
export const movSites = {
    endpoints: {
        test: `https://oi269v5q1a.execute-api.us-east-1.amazonaws.com/test`,
        acceptance: `https://j4qvkrq1p9.execute-api.us-east-1.amazonaws.com/acceptance`,
        prod: `https://cll6npxl1e.execute-api.us-east-1.amazonaws.com/prod`,
    },
    http: {
        create: ({ data, stage, token, cancelToken }) => {
            return axiosTemplate(token, cancelToken).post(`${movSites.endpoints[stage]}/sites`, data);
        },
        remove: ({ siteId, token, stage, cancelToken }) => {
            return axiosTemplate(token, cancelToken).delete(`${movSites.endpoints[stage]}/sites/${siteId}`);
        },
        get: ({ stage, token, cancelToken }) => {
            return axiosTemplate(token, cancelToken).get(`${movSites.endpoints[stage]}/sites`);
        },
        update: ({ data, token, siteId, stage, cancelToken }) => {
            return axiosTemplate(token, cancelToken).put(`${movSites.endpoints[stage]}/sites/${siteId}`, data);
        },
    },
    invocations: {
        addDependent: {
            generateArn: (stage) => `arn:aws:lambda:us-east-1:030010709664:function:mov-sites-${stage}-addDependent`,
            invoke: async ({ mrn, movSiteId, stage, lambda }) => {
                const command = new InvokeCommand({
                    FunctionName: `mov-sites-${stage}-addDependent`,
                    InvocationType: 'RequestResponse',
                    //@ts-ignore this is a typing is a lie, it actually wants JSON
                    Payload: JSON.stringify({
                        mrn,
                        movSiteId,
                    }),
                });
                const { Payload } = await lambda.send(command);
                if (!Payload)
                    return { error: 'no payload' };
                const result = Buffer.from(Payload).toString();
                const response = JSON.parse(result);
                return response;
            },
        },
        removeDependent: {
            generateArn: (stage) => `arn:aws:lambda:us-east-1:030010709664:function:mov-sites-${stage}-removeDependent`,
            invoke: async ({ mrn, movSiteId, stage, lambda }) => {
                const command = new InvokeCommand({
                    FunctionName: `mov-sites-${stage}-removeDependent`,
                    InvocationType: 'RequestResponse',
                    //@ts-ignore this is a typing is a lie, it actually wants JSON
                    Payload: JSON.stringify({
                        mrn,
                        movSiteId,
                    }),
                });
                const { Payload } = await lambda.send(command);
                if (!Payload)
                    return { error: 'no payload' };
                const result = Buffer.from(Payload).toString();
                const response = JSON.parse(result);
                return response;
            },
        },
        get: {
            generateArn: (stage) => `arn:aws:lambda:us-east-1:030010709664:function:mov-sites-${stage}-getInvoke`,
            invoke: async ({ movSiteId, stage, lambda }) => {
                const command = new InvokeCommand({
                    FunctionName: `mov-sites-${stage}-getInvoke`,
                    InvocationType: 'RequestResponse',
                    //@ts-ignore this is a typing is a lie, it actually wants JSON
                    Payload: JSON.stringify({
                        movSiteId,
                    }),
                });
                const { Payload } = await lambda.send(command);
                if (!Payload)
                    return { error: 'no payload' };
                const result = Buffer.from(Payload).toString();
                const response = JSON.parse(result);
                return response;
            },
        },
    },
};
